<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      url: process.env.PATH_IMG,
    }
  },
  created(){
    this.getNavData();
  },
  mounted(){
    this.setFavicon();
  },
  computed: {
    webInfo(){
      let data = {};
      if(this.$store.state.infoData){
        data = this.$store.state.infoData;
      }
      return data;
    },
  },
  methods:{
    setFavicon(){
      if(this.webInfo.siteIcon){
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = this.url + this.webInfo.siteIcon;
        document.getElementsByTagName('head')[0].appendChild(link);
      }
    },
    // 获取版权数据
    getNavData(){
      let _this = this;
      _this.$store.dispatch("getWebConfig");
    },
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* min-width: 1320px; */
  min-width: 1200px;
}
@media only screen and (min-width: 1930px) {
  #app {
    margin: 0 auto;
    max-width: 1920px;
  }
}
#app > div{
  height: 100%;
}
body{
	background: #fff8f1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue